module.exports = __webpack_public_path__ + "images/locator/icon-list-view-inv-7a8e5a12.svg";